(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galpon-carrusel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.galpon-carru').forEach((sec) => {
      const vp = sec.querySelector('[data-carru-vp]');
      const track = sec.querySelector('[data-carru-track]');
      if (!vp || !track) return;
      const firstSet = track.querySelector('[data-carru-set]');
      const prev = sec.querySelector('.galpon-carru__side--prev');
      const next = sec.querySelector('.galpon-carru__side--next');

      let x = 0;                 // posición (negativa = desplazado a la izquierda)
      let setWidth = 0;          // ancho de UN set (loop infinito sobre esto)
      const SPEED = 0.35;        // px/frame — marquee lento premium
      let paused = false;
      let dragging = false;
      let pauseUntil = 0;        // pausa temporal tras interacción (flechas/wheel)

      const stage = sec.querySelector('[data-carru-stage]');
      const measure = () => {
        setWidth = firstSet.getBoundingClientRect().width;
        // centrar las flechas sobre el ALTO DE LA FOTO (no la card completa)
        const media = track.querySelector('.galpon-carru__media');
        if (media && stage) {
          const vpTop = vp.getBoundingClientRect().top;
          const mr = media.getBoundingClientRect();
          const center = (mr.top - vpTop) + mr.height / 2; // centro de la foto desde el top del stage
          stage.style.setProperty('--media-h', center + 'px');
        }
      };

      // loop sin costura: mantener x en (-setWidth, 0]
      const wrap = () => {
        if (setWidth <= 0) return;
        while (x <= -setWidth) x += setWidth;
        while (x > 0) x -= setWidth;
      };
      const apply = () => { track.style.transform = 'translate3d(' + x + 'px,0,0)'; };

      const tick = (now) => {
        const visible = sec.dataset.visible !== '0';
        const tempPaused = now < pauseUntil;
        if (!paused && !dragging && !tempPaused && visible) { x -= SPEED; wrap(); apply(); }
        requestAnimationFrame(tick);
      };

      // --- Drag con mouse (desktop) sobre las fotos ---
      // BUG CAZADO (16-ago): la clase is-dragging NO puede ponerse en mousedown — su CSS
      // apaga pointer-events de las cards, y un CLICK simple (mousedown+mouseup sin mover)
      // terminaba con el mouseup fuera del <a> → el click nunca navegaba al producto.
      // La clase (y el modo drag visual) se activan recién con movimiento real (>4px).
      let startX = 0, startPos = 0, moved = false;
      vp.addEventListener('mousedown', (e) => {
        dragging = true; moved = false; startX = e.pageX; startPos = x;
        e.preventDefault();
      });
      window.addEventListener('mousemove', (e) => {
        if (!dragging) return;
        const dx = e.pageX - startX;
        if (Math.abs(dx) > 4 && !moved) { moved = true; vp.classList.add('is-dragging'); }
        if (moved) { x = startPos + dx; wrap(); apply(); }
      });
      window.addEventListener('mouseup', () => {
        if (!dragging) return;
        dragging = false; vp.classList.remove('is-dragging');
      });
      // un drag no debe disparar el click del enlace de la card
      vp.addEventListener('click', (e) => { if (moved) e.preventDefault(); }, true);

      // --- Swipe táctil (mobile) con INERCIA ---
      // El 1:1 con el dedo sin inercia se sentía tosco y corto (feedback F 17-ago):
      // un flick movía solo los ~150px del gesto, ni una card. Ahora se mide la
      // velocidad del gesto (suavizada) y al soltar el track sigue deslizando con
      // fricción, como el scroll nativo.
      let tStartX = 0, tStartPos = 0, tLastX = 0, tLastT = 0, tVel = 0, glideId = 0;
      vp.addEventListener('touchstart', (e) => {
        cancelAnimationFrame(glideId);
        dragging = true;
        tStartX = e.touches[0].pageX; tStartPos = x;
        tLastX = tStartX; tLastT = performance.now(); tVel = 0;
      }, { passive: true });
      vp.addEventListener('touchmove', (e) => {
        if (!dragging) return;
        const px = e.touches[0].pageX;
        const now = performance.now();
        const dt = now - tLastT;
        if (dt > 0) tVel = 0.8 * ((px - tLastX) / dt) + 0.2 * tVel; // px/ms suavizada
        tLastX = px; tLastT = now;
        x = tStartPos + (px - tStartX); wrap(); apply();
      }, { passive: true });
      vp.addEventListener('touchend', () => {
        dragging = false;
        // inercia: velocidad del flick → px/frame, con tope y fricción por frame
        let v = Math.max(-60, Math.min(60, tVel * 16));
        if (Math.abs(v) < 2) return;
        const glide = () => {
          v *= 0.94;
          if (Math.abs(v) < 0.4 || dragging) return;
          x += v; wrap(); apply();
          pauseUntil = performance.now() + 600; // el marquee no retoma mientras desliza
          glideId = requestAnimationFrame(glide);
        };
        glideId = requestAnimationFrame(glide);
      });

      // --- Wheel horizontal (trackpad: dos dedos) ---
      vp.addEventListener('wheel', (e) => {
        // solo si el gesto es predominantemente horizontal (trackpad swipe)
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          e.preventDefault();
          x -= e.deltaX; wrap(); apply();
          pauseUntil = performance.now() + 600; // pausa breve mientras swipeás
        }
      }, { passive: false });

      // --- Flechas a los costados: salto suave de ~1.5 cards ---
      const card = () => track.querySelector('.galpon-carru__card');
      const jump = (dir) => {
        const c = card();
        const w = c ? c.getBoundingClientRect().width + 24 : 320;
        const target = x + dir * w * 1.5;
        // animar el salto con un tween corto (no instantáneo)
        const from = x, dist = target - from, t0 = performance.now(), dur = 420;
        pauseUntil = t0 + dur + 200;
        const ease = (p) => 1 - Math.pow(1 - p, 3);
        const step = (now) => {
          const p = Math.min(1, (now - t0) / dur);
          x = from + dist * ease(p); wrap(); apply();
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      if (prev) prev.addEventListener('click', () => jump(1));
      if (next) next.addEventListener('click', () => jump(-1));

      // --- Pausa al pasar el mouse sobre las fotos O sobre las flechas ---
      // (las flechas están sobre las fotos → el cursor está en el área del carrusel)
      vp.addEventListener('mouseenter', () => { paused = true; });
      vp.addEventListener('mouseleave', () => { paused = false; });
      [prev, next].forEach((b) => {
        if (!b) return;
        b.addEventListener('mouseenter', () => { paused = true; });
        b.addEventListener('mouseleave', () => { paused = false; });
      });

      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { sec.dataset.visible = en.isIntersecting ? '1' : '0'; });
      }, { threshold: 0 });
      io.observe(sec);

      window.addEventListener('resize', measure, { passive: true });

      const start = () => { measure(); if (!prefersReduced) requestAnimationFrame(tick); };
      if (firstSet.querySelector('img')) requestAnimationFrame(start);
      else start();
      if (prefersReduced) measure();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function arm(host) {
      var grid = host.querySelector('[data-testid="resource-list-grid"], .resource-list');
      if (!grid) return false;
      var cards = grid.querySelectorAll('.resource-list__item');
      if (!cards.length) return false;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;

      // Marca el grid como "armado" -> el CSS aplica opacity:0 a las cards.
      grid.classList.add('gd-rec-armed');

      var reveal = function (card, i) {
        card.style.setProperty('--gd-rec-delay', (i * 90) + 'ms');
        card.classList.add('gd-rec-in');
      };
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          reveal(en.target, [].indexOf.call(grid.children, en.target));
          obs.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

      cards.forEach(function (card, i) {
        var r = card.getBoundingClientRect();
        // Ya visible al armar (pantalla grande / scroll alto) -> revelar al toque.
        if (r.top < vh && r.bottom > 0) reveal(card, i);
        else io.observe(card);
      });
      return true;
    }
    document.querySelectorAll('product-recommendations').forEach(function (host) {
      if (arm(host)) return;
      var mo = new MutationObserver(function () {
        if (arm(host)) mo.disconnect();
      });
      mo.observe(host, { childList: true, subtree: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
